<div [formGroup]="surveyEditorService.surveyEditor$().activeQuestion" class="file-upload-form__container">
  <div class="file-upload-form__config">
    <mat-slide-toggle
      [labelPosition]="'before'"
      [color]="'primary'"
      formControlName="allowMultipleInd"
      [checked]="surveyEditorService.surveyEditor$().activeQuestion.value.allowMultipleInd"
    >
      Allow multiple files
    </mat-slide-toggle>

    <div class="editor-question-form__input">
      <span class="label fs__sm"> Maximum file size (MB) </span>
      <span class="sublabel fs__sm">Limited to 250Mb</span>
      <mat-form-field appearance="outline">
        <input matInput type="number" formControlName="maxSize" max="250" />
      </mat-form-field>
    </div>
  </div>

  <div class="file-upload-form__types">
    <span class="label fs__sm">Select the allowed file types</span>
    <div class="file-upload-form__types-list">
      @for (fileType of fileTypeTexts | keyvalue; track fileType) {
        <mat-checkbox
          class="file-upload-form__types-item"
          color="primary"
          [checked]="valuesSelected$().includes(fileType.key)"
          (change)="onMultiOptionChanged($event, fileType.key)"
        >
          {{ fileType.value | toPlainText }}
        </mat-checkbox>
      }
    </div>

    @if (valuesSelected$().length === 0) {
      <div class="file-upload-form__types-empty">
        <span class="fs__sm">PNG, JPG and GIF are the default options</span>
      </div>
    }
  </div>
</div>
